import { withStyles } from '@material-ui/core';
import appConstants from '../../../../../appConstants';
import { getDeliveryShipmentStatusFromDelCode } from './utils';

const styles = (theme) => ({
  deliveryStatus: {
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: theme.textFontSize,
    marginLeft: 8,
    fontWeight: 600,
    height: 'fit-content'
  },
  pending: {
    color: theme.successTextColor,
    background: theme.activeRadioBG
  },
  returnOrException: {
    color: theme.error,
    background: theme.statusWrapperHighlightedColor
  },
  deliveryCleared: {
    color: theme.dispatchPanelLabelValueColor,
    background: theme.trailerBackgroundColor
  }
});

const getDeliveryStatusDetails = (
  isStopCompleted,
  proData,
  classes,
  dispatchStore,
  enableReturnExceptionReasonLabels
) => {
  let deliveryStatus = isStopCompleted
    ? getDeliveryShipmentStatusFromDelCode(proData.deliveryCode)
    : 'Pending';
  switch (deliveryStatus) {
    case appConstants.DELIVERY_STATUS.RETURN: {
      const statusCode = enableReturnExceptionReasonLabels
        ? dispatchStore?.getReturnDetails(proData.returnCode)?.description ?? proData.returnCode
        : proData.returnCode;
      return {
        deliveryStatus,
        statusCode,
        customClasses: classes.returnOrException
      };
    }
    case appConstants.DELIVERY_STATUS.DELIVERY_EXCEPTION: {
      const exceptionValues = enableReturnExceptionReasonLabels
        ? proData.exceptionCode?.map?.((code) =>
            dispatchStore?.getExceptionDetails(code)?.description ?? code
          ) ?? []
        : proData.exceptionCode ?? [];
      const statusCode = exceptionValues.length > 0 ? exceptionValues.join(', ') : null;
      return {
        deliveryStatus,
        statusCode,
        customClasses: classes.returnOrException
      };
    }
    case appConstants.DELIVERY_STATUS.DELIVERED_CLEAR:
    case appConstants.DELIVERY_STATUS.TENDERED_TO_AGENT:
      return {
        deliveryStatus,
        statusCode: null,
        customClasses: classes.deliveryCleared
      };
    default:
      return {
        deliveryStatus,
        statusCode: null,
        customClasses: classes.pending
      };
  }
};

const DeliveryStatusBadge = ({
  classes,
  isCompleted,
  proData,
  DispatchStore,
  enableReturnExceptionReasonLabels = false
}) => {
  const { deliveryStatus, statusCode, customClasses } = getDeliveryStatusDetails(
    isCompleted,
    proData,
    classes,
    DispatchStore,
    enableReturnExceptionReasonLabels
  );
  return (
    <span className={`${classes.deliveryStatus} ${customClasses}`}>
      {deliveryStatus} {statusCode ? `(${statusCode})` : ''}
    </span>
  );
};

export default withStyles(styles)(DeliveryStatusBadge);
